const STATUS_VALUES=[
  "Supported","Partly supported","Weak evidence","Not demonstrated","Not tested","Misunderstood","Further evidence required",
  "Ready","Approved","Confirmed","In progress","Not started","Needs attention","Stale","Evidence ready","Evidence incomplete",
];

const escape=(value:string)=>value.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");
const statusPattern=new RegExp(`^(.+?)\\s+(?:\\u00e2\\u20ac\\u201d|—)\\s+(${STATUS_VALUES.map(escape).join("|")})$`);

/** Repairs only known encoding damage and explicit status separators. Unknown dash-like text is preserved. */
export function normaliseEditableReportText(value:string){
  return value
    .replaceAll("\u00e2\u20ac\u2122","’")
    .replaceAll("\u00e2\u20ac\u0153","“")
    .replaceAll("\u00e2\u20ac\u009d","”")
    .replace(/(\d)\s*\u00e2\u20ac\u201c\s*(\d)/g,"$1–$2")
    .split(/\r?\n/)
    .map(line=>{const match=line.match(statusPattern);return match?`${match[1]}: ${match[2]}`:line})
    .join("\n");
}

export function normaliseGeneratedReportText(value:string){
  const clean=normaliseEditableReportText(value);
  if(clean.includes("—")||clean.includes("\u00e2\u20ac\u201d"))throw new Error("Generated report wording contains an unsupported em dash.");
  return clean;
}

export function hasReportTextEncodingWarning(value:string){
  return /\u00e2\u20ac|—/.test(value);
}

function normaliseUnknown<T>(value:T):T{
  if(typeof value==="string")return normaliseEditableReportText(value) as T;
  if(Array.isArray(value))return value.map(item=>normaliseUnknown(item)) as T;
  if(value&&typeof value==="object")return Object.fromEntries(Object.entries(value).map(([key,item])=>[key,normaliseUnknown(item)])) as T;
  return value;
}

/** Normalises editable report wording only. Evidence records and locked versions never call this helper. */
export function normaliseEditableSectionWording(section:{id:string;body:string;internalNotes?:string;blocks?:Array<{content:string;title?:string}>;sectionFiveWorkflow?:unknown;sectionSixWorkflow?:unknown;sectionSevenWorkflow?:unknown;sectionEightWorkflow?:unknown;sectionNineWorkflow?:unknown;sectionTenWorkflow?:unknown}){
  if(!["overall-findings","commercial-gaps","competitors","authority-gaps","positioning","work-programme"].includes(section.id))return section;
  return{
    ...section,
    body:normaliseEditableReportText(section.body),
    internalNotes:section.internalNotes==null?section.internalNotes:normaliseEditableReportText(section.internalNotes),
    blocks:section.blocks?.map(block=>({...block,title:block.title==null?block.title:normaliseEditableReportText(block.title),content:normaliseEditableReportText(block.content)})),
    sectionFiveWorkflow:normaliseUnknown(section.sectionFiveWorkflow),
    sectionSixWorkflow:normaliseUnknown(section.sectionSixWorkflow),
    sectionSevenWorkflow:normaliseUnknown(section.sectionSevenWorkflow),
    sectionEightWorkflow:normaliseUnknown(section.sectionEightWorkflow),
    sectionNineWorkflow:normaliseUnknown(section.sectionNineWorkflow),
    sectionTenWorkflow:normaliseUnknown(section.sectionTenWorkflow),
  };
}
